import React, {Component} from "react";
import {introAssetConfig} from "../../../data/intro"
import {configGame} from "../../../data/config";


interface IframeworkBanner {
    data: {
        "BANNER_CONTAINER_X": number,
        "BANNER_CONTAINER_Y": number,
        "COMPONENTS": any
    }

}

export const frameworkBanner: IframeworkBanner = {
    data: {
        "BANNER_CONTAINER_X": 0,
        "BANNER_CONTAINER_Y": 0,
        "COMPONENTS": []
    }


};

export const BannerConfigurationContext = React.createContext(
    {}
);